<!--  Created by   : ANKUSH BHARDWAJ                                                           -->
<!--  Create Dated : 24-NOV-2021                                                              -->
<!--  Purpose      : User Profile                                                             -->
<template>
  <div id="divUserProfile">
    <div class="Flex_Table tblEntryForm">
      <div class="Flex_Row">
        <div class="Flex_Cell" width="60%">
          <fieldset class style="width: 100% !important">
            <div class="Flex_Table tblEntryForm">
              <legend>Personal Details</legend>
              <div class="Flex_Row">
                <div class="Flex_Cell" style="width: 20%">
                  <div class="Flex_Table">
                    <div class="Flex_Row" align="center" valign="middle">
                      <div class="Flex_Cell" style="padding: 0 px 0 px">
                        <img
                          v-if="imgURL != null"
                          :src="imgURL"
                          style="
                            height: 200px;
                            width: 200px;
                            border-radius: 50%;
                            border-weight: 1pt;
                          "
                        />
                        <img
                          v-if="
                            (imgURL == null && gender == 'M') || gender == 0
                          "
                          src="../assets/images/img_avatar.png"
                          style="
                            height: 200px;
                            width: 200px;
                            border-radius: 50%;
                            border-weight: 1pt;
                          "
                        />
                        <img
                          v-if="imgURL == null && gender == 'T'"
                          src="../assets/images/img_avatar.png"
                          style="
                            height: 200px;
                            width: 200px;
                            border-radius: 50%;
                            border-weight: 1pt;
                          "
                        />
                        <img
                          v-if="imgURL == null && gender == 'F'"
                          src="../assets/images/img_avatar2.png"
                          style="
                            height: 200px;
                            width: 200px;
                            border-radius: 50%;
                            border-weight: 1pt;
                          "
                        />
                      </div>
                    </div>
                    <div class="Flex_Row" align="center" valign="middle">
                      <div class="Flex_Cell" align="center" valign="middle" style="width: 200px">
                        <span id="UploadArea">
                          <input type="file" id="ImageBox" v-on:change="ImageChosen($event)" />
                          <span style="color: red">
                            (Image must be in .jpg /.jpeg /.png format and size
                            between 10 to 50 kb only)
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="Flex_Cell" style="width: 80%">
                  <div class="Flex_Table tblEntryForm">
                    <div class="Flex_Row">
                      <div class="Flex_Cell" style="width: 33%">
                        <span class="mandatorySpan" :class="{ Required: false }">User Type &nbsp;</span>
                        <select id="ddlUserType" disabled v-model="userType">
                          <option value="-1">---Select---</option>
                          <option
                            v-for="u in userType_List"
                            :key="u[0]"
                            v-bind:value="u[0]"
                          >{{ u[1] }}</option>
                        </select>
                      </div>
                      <div class="Flex_Cell" style="width: 33%">
                        <span class="mandatorySpan" :class="{ Required: true }">User Mobile Number</span>
                        <AcceptInput
                          maxlength="10"
                          ref="userMobile"
                          disabled
                          type="textbox"
                          :isRequired="true"
                          placeholder="PLEASE ENTER MOBILE NUMBER"
                          v-model="userMobile"
                          class="CreateAccount"
                          regExp="([0-9])*"
                        />
                        <div align="right" v-if="this.userMobile != '' && !mobVerified">
                          <a style="cursor: pointer; size: 10pt; color: red" @click="openPopup">
                            Not Verified
                            <i class="DataIcon glyphicons remove"></i>
                          </a>
                        </div>
                        <div
                          align="right"
                          v-if="this.userMobile != '' && mobVerified"
                          style="size: 10pt; color: green"
                        >
                          Verified
                          <i class="DataIcon glyphicons ok"></i>
                        </div>
                      </div>
                      <div class="Flex_Cell" style="width: 33%">
                        <span class="mandatorySpan" :class="{ Required: true }">User Email</span>
                        <AcceptInput
                          maxlength="100"
                          ref="userEmail"
                          :disabled="this.email != ''"
                          type="email"
                          :isRequired="true"
                          placeholder="PLEASE ENTER EMAIL"
                          v-model="userEmail"
                          class="CreateAccount"
                        />
                        <div
                          align="right"
                          v-if="
                            this.email != '' &&
                            !emailVerified &&
                            isEMailOTPRequired == 1
                          "
                        >
                          <a style="cursor: pointer; size: 10pt; color: red" @click="openPopup">
                            Not Verified
                            <i class="DataIcon glyphicons remove"></i>
                          </a>
                        </div>
                        <div
                          align="right"
                          v-if="
                            this.email != '' &&
                            emailVerified &&
                            isEMailOTPRequired == 1
                          "
                          style="size: 10pt; color: green"
                        >
                          Verified
                          <i class="DataIcon glyphicons ok"></i>
                        </div>
                        <div align="right" v-if="this.email == ''">
                          <a
                            style="cursor: pointer; size: 10pt"
                            @click="updateProfile(5)"
                          >Update Email</a>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="Flex_Row">
                      <div class="Flex_Cell" style="width: 33%">
                        <table style="width: 100%">
                          <tr>
                            <td style="max-width: 20% !important">
                              <span class="mandatorySpan" :class="{ Required: true }">Title &nbsp;</span>
                              <select id="ddlTitle" v-model="title">
                                <option value="-1">---Select---</option>
                                <option
                                  v-for="t in title_List"
                                  :key="t[0]"
                                  v-bind:value="t[0]"
                                >{{ t[1] }}</option>
                              </select>
                            </td>
                            <td style="max-width: 5% !important">&nbsp;</td>
                            <td style="max-width: 75% !important">
                              <span class="mandatorySpan" :class="{ Required: true }">First Name</span>
                              <AcceptInput
                                maxlength="50"
                                ref="fName"
                                type="textbox"
                                :isRequired="true"
                                placeholder="PLEASE ENTER FIRST NAME"
                                v-model="fName"
                                class="CreateAccount"
                                regExp="([A-Z a-z()])*"
                              />
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div class="Flex_Cell" style="width: 33%">
                        <span class="mandatorySpan" :class="{ Required: false }">Middle Name</span>
                        <AcceptInput
                          maxlength="50"
                          ref="mName"
                          type="textbox"
                          placeholder="PLEASE ENTER MIDDLE NAME"
                          v-model="mName"
                          class="CreateAccount"
                          regExp="([A-Z a-z()])*"
                        />
                      </div>
                      <div class="Flex_Cell" style="width: 33%">
                        <span class="mandatorySpan" :class="{ Required: true }">Last Name</span>
                        <AcceptInput
                          maxlength="50"
                          ref="lName"
                          type="textbox"
                          :isRequired="true"
                          placeholder="PLEASE ENTER LAST NAME"
                          v-model="lName"
                          class="CreateAccount"
                          regExp="([A-Z ()a-z])*"
                        />
                      </div>
                    </div>
                    <br />
                    <div class="Flex_Row">
                      <div class="Flex_Cell" style="width: 33%">
                        <span class="mandatorySpan">Date of Birth</span>
                        <DateControl
                          :isRequired="true"
                          style="max-width: 295px !important"
                          v-model="dob"
                        ></DateControl>
                      </div>
                      <div class="Flex_Cell" style="width: 33%">
                        <span class="mandatorySpan" :class="{ Required: true }">Gender</span>
                        <div v-for="g in gender_List" :key="g[2]" class="rblDiv">
                          <input
                            ref="gender"
                            name="rblGender"
                            class="rblgender"
                            type="radio"
                            v-model="gender"
                            :value="g[2]"
                          />
                          &nbsp;{{ g[1] }}
                        </div>
                      </div>
                      <div class="Flex_Cell" style="width: 33%">
                        <span class="mandatorySpan">Full Address</span>
                        <textarea
                          ref="fullAdd"
                          v-model="fullAdd"
                          placeholder="ENTER FULL ADDRESS"
                          title="ENTER FULL ADDRESS"
                          maxlength="500"
                          v-on:keypress="validateAddress($event)"
                          @click.right.prevent
                          @copy.prevent
                          @paste.prevent
                          regExp="([A-Z ' ,-/&@*()'a-z])*"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="Flex_Row" v-if="userTypeID == 2 || userTypeID == 5">
                <div class="Flex_Table tblEntryForm">
                  <legend>Company Details</legend>
                  <div class="Flex_Row">
                    <div class="Flex_Cell">
                      <span class="mandatorySpan" :class="{ Required: true }">Company Name</span>
                      <AcceptInput
                        maxlength="112"
                        ref="CompanyName"
                        type="text"
                        :isRequired="true"
                        placeholder="PLEASE ENTER NAME"
                        v-model="companyName"
                        class="CreateAccount"
                        regExp="([a-zA-Z \'\(\)])*"
                      />
                    </div>
                    <div class="Flex_Cell">
                      <span class="mandatorySpan">Company Website</span>
                      <AcceptInput
                        maxlength="112"
                        ref="CompanyWebsite"
                        type="text"
                        placeholder="PLEASE ENTER WEBSITE"
                        v-model="companyWebsite"
                        class="CreateAccount"
                        regExp="([a-zA-Z0-9\-\.\@\&])*"
                      />
                    </div>
                    <div class="Flex_Cell">
                      <span class="mandatorySpan" :class="{ Required: true }">Company Contact</span>
                      <AcceptInput
                        maxlength="13"
                        ref="CompanyContact"
                        type="text"
                        :isRequired="true"
                        placeholder="PLEASE ENTER CONTACT NUMBER"
                        v-model="companyContact"
                        class="CreateAccount"
                        regExp="([0-9\-\+])*"
                      />
                    </div>
                    <div class="Flex_Cell">
                      <span class="mandatorySpan" :class="{ Required: true }">Company Email</span>
                      <AcceptInput
                        maxlength="112"
                        ref="CompanyEmail"
                        type="text"
                        :isRequired="true"
                        placeholder="PLEASE ENTER EMAIL"
                        v-model="companyEmail"
                        class="CreateAccount"
                        regExp="([a-zA-Z0-9 \.\_\-\@])*"
                      />
                    </div>
                    <div class="Flex_Cell">
                      <span class="mandatorySpan">Comments (If any)</span>
                      <textarea
                        ref="CompanyComment"
                        v-model="companyComment"
                        placeholder="PLEASE ENTER COMMENT (IF ANY)"
                        title="PLEASE ENTER COMMENT (IF ANY)"
                        maxlength="500"
                        regExp="([a-zA-Z0-9 \.\_\-\@\(\)])*"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="Flex_Row" align="right" valign="middle">
                <div class="Flex_Cell">
                  <input
                    type="button"
                    v-model="saveProfile"
                    style="padding: 10px"
                    title="Click to SaveProfile"
                    @click="updateProfile(1)"
                  />
                </div>
              </div>-->
              <div class="Flex_Row" v-if="userTypeID == 2 || userTypeID == 5">
                <div class="Flex_Table">
                  <legend>Upload Document</legend>
                  <div class="Flex_Row">
                    <div class="Flex_Table ekkGrid" style="border-radius: 6px" align="center">
                      <div class="Flex_Row GridHeader" valign="middle" style="min-height: 40px">
                        <div class="Flex_Cell" style="width: 33%">
                          <span>DOCUMENT TYPE</span>
                        </div>
                        <div class="Flex_Cell" style="width: 33%">
                          <span>DOCUMENT NUMBER</span>
                        </div>
                        <div class="Flex_Cell" style="width: 34%">
                          <span>
                            CHOOSE ID FILE
                            <br />
                            <span style>
                              (File must be in .jpg /.jpeg /.png /.pdf format
                              and size between 10 to 50 kb only)
                            </span>
                          </span>
                        </div>
                        <!-- <div class="Flex_Cell" style="width: 10%">
                          <span>Add / Delete</span>
                        </div>-->
                      </div>
                      <div
                        class="Flex_Row GridContent"
                        v-for="(i, index) in idType_List"
                        :key="i.idType"
                        valign="middle"
                      >
                        <!-- <div class="Flex_Cell" style="width: 30%">
                          <select id="ddlIDType" v-model="idType">
                            <option selected value="-1">---Select---</option>
                            <option
                              v-for="i in idType_List"
                              :key="i[0]"
                              v-bind:value="i[0]"
                            >
                              {{ i[1] }}
                            </option>
                          </select>
                        </div>-->
                        <div class="Flex_Cell" style="width: 33%">
                          <span
                            class="mandatorySpan1"
                            :class="{ Required: true }"
                            v-if="i.idType == 2 || i.idType == 3"
                          >{{ index + 1 }}. {{ i.idTypeName.toUpperCase() }}</span>
                          <span class="mandatorySpan1" :class="{ Required: false }" v-else>
                            {{ index + 1 }}.
                            {{ i.idTypeName.toUpperCase() }}
                          </span>
                        </div>
                        <div class="Flex_Cell" style="width: 33%">
                          {{ i.idNumberDisplay }}
                          <AcceptInput
                            v-if="i.idType == 1 || i.idType == 4"
                            maxlength="30"
                            ref="idNumber"
                            type="text"
                            :isRequired="i.idType != 4"
                            :placeholder="
                              'ENTER ' + i.idTypeName.toUpperCase()
                            "
                            v-model="i.idNumber"
                            class="CreateAccount"
                            regExp="([A-Z ()0-9a-z])*"
                          />
                          <input
                            v-else
                            maxlength="30"
                            ref="idNumber"
                            type="password"
                            :isRequired="i.idType != 4"
                            :placeholder="
                              'ENTER ' + i.idTypeName.toUpperCase()
                            "
                            v-model="i.idNumber"
                            class="CreateAccount"
                            regExp="([A-Z ()0-9a-z])*"
                          />
                          <!-- <AcceptInput
                            maxlength="30"
                            ref="idNumber"
                            type="textbox"
                            v-model="i.idNumber"
                            v-else
                            :placeholder="
                              'PLEASE ENTER ' + i.idTypeName.toUpperCase()
                            "
                            class="CreateAccount"
                            regExp="([A-Z ()0-9a-z])*"
                          />-->
                        </div>
                        <div class="Flex_Cell" style="width: 34%">
                          <input
                            type="file"
                            id="FileBox"
                            v-on:change="FileChosen($event, i.idType)"
                          />
                          <span>{{ i.idImageFileName }}</span>
                        </div>
                        <!-- <div class="Flex_Cell_Inline" style="width: 10%">
                          <span
                            class="glyphicons circle_plus"
                            v-on:click="addDocuments()"
                            style="cursor: pointer; color: Green"
                            title="Edit"
                          ></span>
                        </div>-->
                      </div>
                      <!-- <div
                        class="Flex_Row GridContent"
                        v-for="(row, index) in document_List"
                        :key="index"
                        valign="middle"
                        style="min-height: 30px"
                      >
                        <div class="Flex_Cell" width="30%">
                          {{ row.idTypeName }}
                        </div>
                        <div class="Flex_Cell" width="30%">
                          {{ row.idNumber }}
                        </div>
                        <div class="Flex_Cell" width="30%">
                          {{ row.idImageFileName }}
                        </div>
                        <div class="Flex_Cell" width="10%">
                          <span
                            class="glyphicons circle_remove"
                            v-on:click="removeDocuments(index)"
                            style="cursor: pointer; color: Red"
                            title="Edit"
                          ></span>
                        </div>
                      </div>-->
                    </div>
                  </div>
                  <!-- <div class="Flex_Row" align="right" valign="middle">
                    <div class="Flex_Cell">
                      <input
                        type="button"
                        v-on:click="updateProfileDocFile()"
                        value="Save Documents"
                        style="padding: 10px"
                      />
                    </div>
                  </div>-->
                </div>
              </div>
              <div class="Flex_Row" align="right" valign="middle">
                <div class="Flex_Cell">
                  <input
                    type="button"
                    v-model="saveProfile"
                    style="padding: 10px"
                    title="Click to SaveProfile"
                    @click="updateProfile(1)"
                  />
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <ModalPopup
        title="User Activation Pending! Please Verify OTP"
        ref="ModalPopup2"
        @closed="modalPopupClosed"
        @opened="modalPopupShown"
        v-model="isVerifyOTPReq"
        :okButton="$refs.btnOk"
        :cancelButton="$refs.btnOk"
      >
        <div id="dvVerifyOTP" v-if="isVerifyOTPReq">
          <div class="Flex_Table CreateLoginContent tblEntryForm">
            <div class="Flex_Row" v-if="!emailVerified">
              <div class="Flex_Cell" style="width: 75%">
                <span class="mandatorySpan" :class="{ Required: false }">Email &nbsp;</span>
                <AcceptInput
                  maxlength="112"
                  ref="emailID"
                  type="email"
                  :isRequired="true"
                  placeholder="PLEASE ENTER YOUR EMAIL"
                  v-model="email"
                  class="CreateAccount"
                  :disabled="true"
                />
              </div>
              <div class="Flex_Cell" style="width: 25%">
                <span class="mandatorySpan" :class="{ Required: false }">OTP &nbsp;</span>
                <AcceptInput
                  maxlength="6"
                  style="padding-left:0 padding-right:0"
                  ref="emailOTP"
                  type="textbox"
                  v-model="emailOTP"
                  :isRequired="true"
                  class="CreateAccount"
                  placeholder="OTP"
                  regExp="([0-9])*"
                />
              </div>
            </div>
            <div class="Flex_Row" v-if="!mobVerified" style="margin-top: 10px">
              <div class="Flex_Cell" style="width: 75%">
                <span class="mandatorySpan" :class="{ Required: false }">Mobile &nbsp;</span>
                <AcceptInput
                  maxlength="10"
                  style="padding-left:0 padding-right:0"
                  ref="mobile"
                  type="textbox"
                  v-model="mob"
                  :isRequired="true"
                  placeholder="PLEASE ENTER YOUR MOBILE NO."
                  class="CreateAccount"
                  regExp="([0-9])*"
                  :disabled="true"
                />
              </div>
              <div class="Flex_Cell" style="width: 25%">
                <span class="mandatorySpan" :class="{ Required: false }">OTP &nbsp;</span>
                <AcceptInput
                  maxlength="6"
                  style="padding-left:0 padding-right:0"
                  ref="mobileOTP"
                  type="textbox"
                  v-model="mobileOTP"
                  :isRequired="true"
                  class="CreateAccount"
                  placeholder="OTP"
                  regExp="([0-9])*"
                />
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell" style="width: 40%">
                <span class="mandatorySpan">
                  Captcha &nbsp;
                  <span style="color: red; font-weight: bold; size: 10px">*</span>
                </span>
                <AcceptInput
                  type="text"
                  style="padding-left:0 padding-right:0"
                  v-model="captchaValueEmailVerification"
                  maxlength="6"
                />
              </div>
              <div class="Flex_Cell" style="width: 30%; padding-left: 10px" v-align="bottom">
                <img
                  id="imgCaptchaForEmailVerification"
                  style="border: 1px solid #000; height: 50%"
                />
              </div>
              <div
                class="Flex_Cell"
                align="left"
                v-align="bottom"
                style="width: 30%; padding-top: 6px; padding-left: 0px"
              >
                <img
                  src="../assets/images/refresh.png"
                  v-on:click="generateCaptcha()"
                  style="
                    cursor: pointer;
                    height: 25px;
                    border: 1px solid #000;
                    border-radius: 50%;
                  "
                  title="Click here to refresh captcha"
                />
              </div>
            </div>
            <div class="Flex_Row" align="left">
              <div class="Flex_Cell" style="width: 75%">
                <input
                  type="button"
                  v-model="btnName"
                  style="padding: 10px"
                  v-on:click="generateForgotOTP(1)"
                  :disabled="isDisabled"
                />
                <span v-if="isOTPTimeLeft">
                  Resend OTP after
                  {{
                  this.minutesLeft +
                  ":" +
                  (this.secondsLeft > 9
                  ? this.secondsLeft
                  : "0" + this.secondsLeft)
                  }}
                </span>
              </div>
              <div class="Flex_Cell" style="width: 25%">
                <input
                  type="button"
                  value="Verify OTP"
                  style="padding: 10px"
                  v-on:click="verifyOTP(1)"
                />
              </div>
            </div>
          </div>
          <div class="Flex_Table" style="padding: 5px" v-if="eMailOTPRef != ''">
            <div class="Flex_Row" v-if="!emailVerified">
              <div class="Flex_Cell">
                EMAIL:
                <span>
                  OTP is sent in your email with
                  <b>{{ eMailOTPRef }}</b> ref
                  id
                </span>
              </div>
            </div>
            <div class="Flex_Row" v-if="!mobVerified">
              <div class="Flex_Cell">
                MOBILE:
                <span>
                  OTP is sent in your mobile with
                  <b>{{ mobileOTPRef }}</b> ref
                  id
                </span>
              </div>
            </div>
          </div>
        </div>
      </ModalPopup>
    </div>
  </div>
</template>
<script>
import AcceptInput from "./ekkControls/AcceptInput";
import DateControl from "./ekkControls/DateControl";
import Master from "./servicesJS/Master.js";
import LoginJs from "./servicesJS/Login.js";
import MasterEntry from "./servicesJS/MasterEntry";
import UserProfile from "./servicesJS/UserProfile";
import ModalPopup from "./ekkControls/ModalPopup";
import biometricJS from "../router/biometric.js";

export default {
  name: "MasterEntry",
  components: {
    AcceptInput: AcceptInput,
    DateControl: DateControl,
    ModalPopup: ModalPopup
  },
  data() {
    return {
      userID: -1,
      fName: "",
      mName: "",
      lName: "",
      dob: new Date("01 Jan 1900"),
      userType: -1,
      userTypeID: -1,
      userType_List: [],
      title: -1,
      title_List: [],
      gender: "M",
      gender_List: [],
      userMobile: "",
      mob: "",
      userEmail: "",
      email: "",
      imgURL: null,
      fileURL: null,
      imgData: null,
      fileData: null,
      uploadedImg: [],
      uploadedFile: [],
      idType_List: [],
      fullAdd: "",
      idType: -1,
      idNumber: "",
      idFileName: "",
      saveProfile: "Save",
      savePassword: "Save Profile Password",
      userPass: "",
      confirmPass: "",
      mobVerified: false,
      emailVerified: false,
      isVerifyOTPReq: false,
      isEMailOTPRequired: false,
      isMobileOTPRequired: false,
      verifyCredential: "Generate OTP",
      isDisabled: false,
      eMailOTPRef: "",
      mobileOTPRef: "",
      isOTPTimeLeft: false,
      emailOTP: "",
      mobileOTP: "",
      document_List: [],
      document_TempList: [],
      companyName: "",
      companyWebsite: "",
      companyContact: "",
      companyEmail: "",
      companyComment: "",

      userProfile_List: [],
      captchaKeyEmailVerification: "",
      captchaValueEmailVerification: ""
    };
  },
  methods: {
    decrypt(text) {
      return biometricJS.decryptAES(text);
    },
    modalPopupClosed(e) {
      //this.hideCreateAccount();
    },
    modalPopupShown(e) {
      //console.log("Modal Popup Shown");
    },
    validateAddress: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      var ok =
        (charCode >= 48 && charCode <= 57) ||
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 96 && charCode <= 105) ||
        (charCode >= 97 && charCode <= 122) ||
        charCode == 45 ||
        charCode == 32 ||
        charCode == 44 ||
        charCode == 47;
      if (!ok) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getUserType() {
      this.userType_List = [];
      const _data_ = { isActive: -1, type: 2 };
      MasterEntry.getUserType(_data_).then(
        response => {
          this.userType_List = response.data;
          if (response.data.length > 0) {
            this.getTitle();
            //console.log(this.userType_List);
          }
        },
        error => {}
      );
    },
    getTitle() {
      this.title_List = [];
      const _data_ = { rankID: -1, isActive: 1, type: 1 };
      MasterEntry.getRank(_data_).then(
        response => {
          this.title_List = response.data;
          if (response.data.length > 0) {
            this.getGenderList();
            //console.log(this.title_List);
          }
        },
        error => {}
      );
    },
    getGenderList() {
      this.gender_List = [];
      const _data_ = { genderID: -1, isActive: 1, type: 1 };
      Master.getGenderList(_data_).then(
        response => {
          this.gender_List = response.data;
          if (response.data.length > 0) {
            //console.log(this.gender_List);
            this.getUserProfile();
          }
        },
        error => {}
      );
    },
    // getIDTypeList() {
    //   this.idType_List = [];
    //   const _data_ = {};
    //   Master.getIDTypeList(_data_).then(
    //     (response) => {
    //       this.idType_List = response.data;
    //       if (response.data.length > 0) {
    //         //console.log(this.idType_List);
    //       }
    //     },
    //     (error) => {}
    //   );
    // },
    getUserProfile() {
      this.userProfile_List = [];
      const _data_ = { type: 1 };
      UserProfile.getUserProfile(_data_).then(
        response => {
          this.userProfile_List = response.data;
          if (response.data.length > 0) {
            this.fillUserProfile(this.userProfile_List);
          }
        },
        error => {}
      );
    },
    getUserDocData() {
      this.idType_List = [];
      const _data_ = { type: 1 };
      UserProfile.getUserDocument(_data_).then(
        response => {
          if (response.data.length > 0) {
            response.data.forEach(s => {
              this.idType_List.push({
                idNumber: "",
                idDocument: s.idDocument,
                idImageFile: s.idImageFile,
                idImageFileExtension: s.idImageFileExtension,
                idImageFileName: s.idImageFileName,
                idType: s.idType,
                idTypeName: s.idTypeName,
                type: s.type,
                number: s.idNumber,
                idNumberDisplay:
                  s.idType == 2 || s.idType == 3
                    ? this.decrypt(s.idNumber) != ""
                      ? this.decrypt(s.idNumber)
                          .substring(
                            this.decrypt(s.idNumber).length > 4
                              ? this.decrypt(s.idNumber).length - 4
                              : this.decrypt(s.idNumber).length - 2
                          )
                          .padStart(this.decrypt(s.idNumber).length, "*")
                      : ""
                    : this.decrypt(s.idNumber)
              });
            });
            // console.log(this.idType_List);
          }
        },
        error => {}
      );
    },
    fillUserProfile(result) {
      //console.log(result);
      var mobile = this.decrypt(result[0].userMobile);
      var email = this.decrypt(result[0].userEmail);
      this.fName = result[0].fName;
      this.mName = result[0].mName;
      this.lName = result[0].lName;
      this.userType = result[0].userTypeID;
      this.userTypeID = result[0].userTypeID;
      this.title = result[0].rankID;
      this.dob = result[0].dob;
      this.gender = result[0].gender;
      this.userMobile =
        mobile != ""
          ? mobile
              .substring(
                mobile.length > 4 ? mobile.length - 4 : mobile.length - 2
              )
              .padStart(mobile.length, "*")
          : "";
      this.mob = result[0].userMobile;
      this.userEmail =
        email != ""
          ? email
              .substring(
                email.split("@")[0].length > 6
                  ? email.split("@")[0].length - 4
                  : email.split("@")[0].length - 2
              )
              .padStart(email.length, "*")
          : "";
      this.email = result[0].userEmail;
      this.fullAdd = result[0].fullAddress;
      this.idNumber = result[0].idNumber;
      this.mobVerified = result[0].isMobileActivated;
      this.emailVerified = result[0].isEMailActivated;
      if (result[0].profileImage != "") {
        this.imgURL = "data:image/jpeg;base64,".concat(result[0].profileImage);
      }
      this.companyName = result[0].companyName;
      this.companyWebsite = result[0].companyWebSiteName;
      this.companyContact = this.decrypt(result[0].companyMobile);
      this.companyEmail = this.decrypt(result[0].companyEmail);
      this.companyComment = result[0].companyRemarks;
      this.getUserDocData();
    },
    updateProfile(type) {
      var document_List1 = [];
      var document_List2 = [];
      if (type == 5) {
        if (this.checkPrams(this.email) == true) {
          if (this.checkPrams(this.userEmail) == true) {
            MessageBox.show({
              message: "Please Type Email",
              type: "error",
              title: "Error"
            });
            return;
          } else {
            this.email = this.userEmail;
          }
        }
      } else if (type == 4) {
        if (this.checkPrams(this.userPass) == true) {
          MessageBox.show({
            message: "Please Type Password",
            type: "error",
            title: "Error"
          });
          return;
        }
        if (this.checkPrams(this.confirmPass) == true) {
          MessageBox.show({
            message: "Please Type Confirm Password",
            type: "error",
            title: "Error"
          });
          return;
        }
        if (this.userPass.length < 8) {
          MessageBox.show({
            message: "Password Length Must Be 8 Characters Long.",
            type: "error",
            title: "Error"
          });
          return;
        }
        if (this.userPass != this.confirmPass) {
          MessageBox.show({
            message: "Confirm Password should be same as New Password",
            type: "error",
            title: "Error"
          });
          return;
        }
      } else {
        if (this.checkPrams(this.title) == true) {
          MessageBox.show({
            message: "Please Select Title",
            type: "error",
            title: "Error"
          });
          return;
        }
        if (this.checkPrams(this.fName) == true) {
          MessageBox.show({
            message: "Please Type First Name",
            type: "error",
            title: "Error"
          });
          return;
        }
        if (this.checkPrams(this.lName) == true) {
          MessageBox.show({
            message: "Please Type Last Name",
            type: "error",
            title: "Error"
          });
          return;
        }
        // if (this.checkPrams(this.dob) == true) {
        //   MessageBox.show({
        //     message: "Please Select Date of Birth",
        //     type: "error",
        //     title: "Error",
        //   });
        //   return;
        // }
        if (this.checkPrams(this.gender) == true) {
          MessageBox.show({
            message: "Please Select Gender",
            type: "error",
            title: "Error"
          });
          return;
        }
        if (this.checkPrams(this.mob) == true) {
          MessageBox.show({
            message: "Please Type Mobile Number",
            type: "error",
            title: "Error"
          });
          return;
        }
        if (this.userTypeID == 2 || this.userTypeID == 5) {
          if (this.checkPrams(this.companyName) == true) {
            MessageBox.show({
              message: "Please Type Company Name",
              type: "error",
              title: "Error"
            });
            return;
          }
          // if (this.checkPrams(this.companyWebsite) == true) {
          //   MessageBox.show({
          //     message: "Please Type Company Website",
          //     type: "error",
          //     title: "Error",
          //   });
          //   return;
          // }
          if (this.checkPrams(this.companyContact) == true) {
            MessageBox.show({
              message: "Please Type Company Contact",
              type: "error",
              title: "Error"
            });
            return;
          }
          if (this.checkPrams(this.companyEmail) == true) {
            MessageBox.show({
              message: "Please Type Company Email",
              type: "error",
              title: "Error"
            });
            return;
          }
          let isAllDocumentUploaded = true;
          this.idType_List.forEach(function(item, index) {
            var object = new Object();
            var object1 = new Object();
            if (
              (item.idType == 2 || item.idType == 3) &&
              item.number == "" &&
              item.idNumber == ""
            ) {
              // MessageBox.show({
              //   message: "Please Fill the mandatory documents",
              //   type: "error",
              //   title: "Error",
              // });
              FlashMessage.show(
                "<span style='color:Red'>" +
                  "Please Fill the " +
                  item.idTypeName +
                  "</span><br/>",
                6000
              );
              isAllDocumentUploaded = false;
              return;
            }
            if (
              (item.number != null && item.number != "") ||
              (item.idNumber != null && item.idNumber != "")
            ) {
              var encIDNumber =
                item.idNumber != ""
                  ? biometricJS.encryptAES(item.idNumber)
                  : item.number != ""
                  ? item.number
                  : "";
              object.IDType = item.idType;
              object.IDTypeName = item.idTypeName;
              object.IDNumber = encIDNumber;
              document_List1.push(object);
            }
            if (item.idImageFileName != "") {
              object1.IDType = item.idType;
              object1.IDImageFileName = item.idImageFileName;
              object1.IDImageFile = item.idImageFile;
              object1.IDImageFileExtension = item.idImageFileExtension;
              document_List2.push(object1);
            }
          });
          if (!isAllDocumentUploaded) {
            return false;
          }
          this.uploadedFile.forEach(function(item, index) {
            var object = new Object();
            if (item.docTypeID != null) {
              if (
                document_List2.filter(s => {
                  return s.IDType == item.docTypeID;
                }).length > 0
              ) {
                document_List2.filter(s => {
                  return s.IDType == item.docTypeID;
                })[0].IDImageFileName = item.docFileName;
                document_List2.filter(s => {
                  return s.IDType == item.docTypeID;
                })[0].IDImageFile = item.filePreview;
                document_List2.filter(s => {
                  return s.IDType == item.docTypeID;
                })[0].IDImageFileExtension = item.ext;
              } else {
                object.IDType = item.docTypeID;
                object.IDImageFileName = item.docFileName;
                object.IDImageFile = item.filePreview;
                object.IDImageFileExtension = item.ext;
                document_List2.push(object);
              }
            }
          });
          console.log(document_List1);
          if (document_List1.length == 0 || document_List2.length == 0) {
            MessageBox.show({
              message: "Please Fill Document Details",
              type: "error",
              title: "Error"
            });
            return;
          } else if (document_List1.length != document_List2.length) {
            MessageBox.show({
              message: "Please fill document number and file both.",
              type: "error",
              title: "Error"
            });
            return;
          }
        }
      }
      var basicData = {
        UserTypeID: this.userTypeID,
        RankID: this.title,
        FName: this.fName,
        MName: this.mName,
        LName: this.lName,
        DOB: this.dob,
        Gender: this.gender,
        UserMobile: this.mob,
        UserEmail: this.email,
        UserPassword: "",
        IDType: -1,
        FullAddress: this.fullAdd,
        ProfileImage: "",
        ProfileImageName: "",
        ProfileImageExtention: "",
        UserPassword: this.userPass,
        CompanyName: this.companyName,
        CompanyWebsiteName: this.companyWebsite,
        companyMobile: this.companyContact,
        CompanyEmail: this.companyEmail,
        CompanyRemarks: this.companyComment,

        IDType: document_List1,
        IDDocument: document_List2,
        Type: type
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));
      UserProfile.updateUserProfile(formData).then(
        response => {
          //console.log(response);
          var msg = response.data[0][0];
          var isSuccess = response.data[0][1];
          if (isSuccess == "1") {
            MessageBox.show({
              message: msg,
              type: "success",
              title: "Success"
            });
            this.getUserProfile();
            this.userPass = "";
            var lblPasswordStreingth = document.getElementById(
              "lblPasswordStreingth"
            );
            lblPasswordStreingth.innerHTML = "";
            lblPasswordStreingth.style.border = "";
            lblPasswordStreingth.style.color = "";
            this.confirmPass = "";
            var lblConfirmPassword = document.getElementById(
              "lblConfirmPassword"
            );
            lblConfirmPassword.innerHTML = "";
            lblConfirmPassword.style.border = "";
            lblConfirmPassword.style.color = "";
          } else {
            MessageBox.show({
              message: msg,
              type: "error",
              title: "Error"
            });
          }
        },
        error => {}
      );
    },
    ImageChosen(evnt) {
      this.getImageData(evnt);
    },
    getImageData(event) {
      var extImg = ["JPG", "JPEG", "PNG"];
      var meImg = this;
      var myImage = [];

      var lstImage = event.target.files;
      var isValidImgExtension = true;
      var isValidImgSize = true;
      var isMinValidImgSize = true;
      var minCheckImgSize = parseFloat(10 * 1024);
      var checkImgSize = parseFloat(50 * 1024);

      for (var i = 0; i < lstImage.length; i++) {
        var ImgName = lstImage[i].name;
        var ImgExt = ImgName.split(".").pop();
        if (!(extImg.indexOf(ImgExt.toUpperCase()) >= 0)) {
          isValidImgExtension = false;
        }
        var Imgsize = lstImage[i].size;
        if (parseFloat(Imgsize) < minCheckImgSize) {
          isMinValidImgSize = false;
        }

        if (parseFloat(Imgsize) > checkImgSize) {
          isValidImgSize = false;
        }
        myImage.push(lstImage[i]);
      }

      if (isValidImgExtension == false) {
        alert("Unsupported media type.");
        event.target.value = "";
        return false;
      }
      if (isMinValidImgSize == false) {
        alert(
          "Individual files minimum size should be more than " +
            parseFloat(minCheckImgSize) / 1024 +
            " KB"
        );
        event.target.value = "";
        return false;
      }
      if (isValidImgSize == false) {
        alert(
          "Individual files size should be less than " +
            parseFloat(checkImgSize) / 1024 +
            " KB."
        );
        event.target.value = "";
        return false;
      }
      myImage.forEach(element => {
        var ImgName = element.name;
        var ImgExt = ImgName.split(".").pop();
        var readerImg = new FileReader();
        readerImg.addEventListener("load", function(e) {
          var objectImg = new Object();
          objectImg.file = element;
          objectImg.filePreview = e.target.result;
          objectImg.docFileName = ImgName;
          objectImg.percent = 0;
          objectImg.docFileID = "-1";
          objectImg.isUplodError = false;
          objectImg.isApproved = false;
          objectImg.ext = ImgExt;
          meImg.uploadedImg.push(objectImg);
        });
        if (extImg.indexOf(ImgExt.toUpperCase()) >= 0) {
          readerImg.readAsDataURL(element);
        }
      });
      window.setTimeout(function() {
        meImg.updateProfileImage();
      }, 500);
    },
    updateProfileImage() {
      var img = "";
      var imgName = "";
      var imgExt = "";
      this.uploadedImg.forEach(function(item, index) {
        img = item.filePreview.split(",")[1];
        imgName = item.docFileName;
        imgExt = item.ext;
      });
      var basicData = {
        UserTypeID: 0,
        RankID: 0,
        FName: "",
        MName: "",
        LName: "",
        DOB: "",
        Gender: 0,
        UserMobile: "",
        UserEmail: "",
        UserPassword: "",
        FullAddress: "",
        ProfileImage: img,
        ProfileImageName: imgName,
        ProfileImageExtention: imgExt,
        UserPassword: "",
        CompanyName: "",
        CompanyWebsiteName: "",
        companyMobile: "",
        CompanyEmail: "",
        CompanyRemarks: "",

        IDType: "",
        IDDocument: "",
        Type: 2
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));
      UserProfile.updateUserProfile(formData).then(
        response => {
          //console.log(response);
          var msg = response.data[0][0];
          var isSuccess = response.data[0][1];
          if (isSuccess == "1") {
            MessageBox.show({
              message: "Profile Image uploaded successfully...",
              type: "success",
              title: "Success"
            });
          } else {
            MessageBox.show({
              message: "Something went wrong...",
              type: "error",
              title: "Error"
            });
          }
          this.getUserProfile();
        },
        error => {}
      );
    },
    FileChosen(evnt, docTypeID) {
      this.getFileData(evnt, docTypeID);
    },
    getFileData(event, docTypeID) {
      var ext = ["PDF", "JPG", "JPEG", "PNG"];
      var me = this;
      var myFiles = [];

      var lstFiles = event.target.files;
      var isValidExtension = true;
      var isValidSize = true;
      var isMinValidSize = true;
      var minCheckSize = parseFloat(10 * 1024);
      var checkSize = parseFloat(50 * 1024);

      for (var i = 0; i < lstFiles.length; i++) {
        var fName = lstFiles[i].name;
        var fileExt = fName.split(".").pop();
        if (!(ext.indexOf(fileExt.toUpperCase()) >= 0)) {
          isValidExtension = false;
        }
        var size = lstFiles[i].size;
        if (parseFloat(size) < minCheckSize) {
          isMinValidSize = false;
        }

        if (parseFloat(size) > checkSize) {
          isValidSize = false;
        }
        myFiles.push(lstFiles[i]);
      }

      if (isValidExtension == false) {
        alert("Unsupported media type.");
        event.target.value = "";
        return false;
      }
      if (isMinValidSize == false) {
        alert(
          "Individual files minimum size should be more than " +
            parseFloat(minCheckSize) / 1024 +
            " KB"
        );
        event.target.value = "";
        return false;
      }
      if (isValidSize == false) {
        alert(
          "Individual files size should be less than " +
            parseFloat(checkSize) / 1024 +
            " KB."
        );
        event.target.value = "";
        return false;
      }
      myFiles.forEach(element => {
        var fName = element.name;
        var fileExt = fName.split(".").pop();
        var reader = new FileReader();
        reader.addEventListener("load", function(e) {
          var object = new Object();
          object.docTypeID = docTypeID;
          object.filePreview = e.target.result.split(",")[1];
          object.docFileName = fName;
          object.ext = fileExt;
          me.uploadedFile.push(object);
        });
        if (ext.indexOf(fileExt.toUpperCase()) >= 0) {
          reader.readAsDataURL(element);
        }
      });
    },
    updateProfileDocFile() {
      //this.document_List = this.idType_List;
      var document_List1 = [];
      var document_List2 = [];
      this.idType_List.forEach(function(item, index) {
        var object = new Object();
        object.IDType = item[0];
        object.IDTypeName = item[1];
        object.IDNumber = item[2];
        document_List1.push(object);
      });
      this.uploadedFile.forEach(function(item, index) {
        var object = new Object();
        object.IDType = item.docTypeID;
        object.IDImageFileName = item.docFileName;
        object.IDImageFile = item.filePreview;
        object.IDImageFileExtension = item.ext;
        document_List2.push(object);
      });

      var basicData = {
        IDType: document_List1,
        IDDocument: document_List2,
        Type: 1
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));
      UserProfile.updateUserDocFile(formData).then(
        response => {
          //console.log(response);
          var msg = response.data[0][0];
          var isSuccess = response.data[0][1];
          if (isSuccess) {
            MessageBox.show({
              message: msg,
              type: "success",
              title: "Success"
            });
          } else {
            MessageBox.show({
              message: "Something went wrong...",
              type: "error",
              title: "Error"
            });
          }
          this.getUserProfile();
        },
        error => {}
      );
    },
    checkPrams(_param) {
      var _isError = false;
      if (_param == "" || _param == -1 || _param == null || _param == 0) {
        _isError = true;
      }
      if (_isError) {
        return _isError;
      }
    },
    GetSetupData() {
      const _data_ = {};
      Master.getSetupData().then(
        response => {
          this.SetupData = response.data;
          this.isMobileOTPRequired = response.data[0][6];
          this.isEMailOTPRequired = response.data[0][7];
          this.getUserType();
        },
        error => {}
      );
    },
    openPopup() {
      this.isVerifyOTPReq = true;
      this.generateCaptcha();
      this.btnName = "Generate OTP";
    },
    countDownTimer() {
      if (this.timeLeft) {
        setTimeout(() => {
          if (this.secondsLeft > 0) {
            this.secondsLeft--;
          } else if (this.secondsLeft == 0 && this.minutesLeft >= 0) {
            this.secondsLeft = 59;
            this.minutesLeft--;
          }
          if (this.minutesLeft < 0) {
            this.secondsLeft = 0;
            this.minutesLeft = 0;
            this.timeLeft = false;
          }
          this.countDownTimer();
        }, 1000);
      } else {
        this.isDisabled = false;
      }
    },
    generateForgotOTP(type) {
      let email = "";
      let mobile = "";
      mobile = this.userMobile.trim();
      email = this.userEmail.trim();
      if (email == "") {
        FlashMessage.show(
          "<span style='color:Red'>Please Enter Email</span><br/>",
          3000
        );
        return false;
      }
      if (mobile == "") {
        FlashMessage.show(
          "<span style='color:Red'>Please Enter Mobile</span><br/>",
          3000
        );
        return false;
      }
      if (this.captchaValueEmailVerification == "") {
        FlashMessage.show(
          "<span style='color:Red'>Please Enter Captcha</span><br/>",
          3000
        );
        return false;
      }
      let _paramsData = {
        userID: this.UserID,
        userEMail: email,
        userMobile: mobile,
        type: type,
        captchaValueEmailVerification: this.captchaValueEmailVerification,
        captchaKeyEmailVerification: this.captchaKeyEmailVerification
      };
      UserProfile.resendOTP(_paramsData).then(
        response => {
          if (response.data.isSuccess) {
            if (type == 1) {
              this.isOTPTimeLeft = true;
            }
            this.UserID = response.data.userID;
            this.forgotOTPSend = true;
            this.minutesLeft = 1;
            this.secondsLeft = 59;
            this.timeLeft = true;
            this.countDownTimer();
            this.btnName = "Resend OTP";
            this.isDisabled = true;
            if ((type = 1)) {
              this.eMailOTPRef = response.data.emailOTPRef;
            }
            this.mobileOTPRef = response.data.mobileOTPRef;
            this.IsEMailActivated = response.data.isEMailActivated;
            this.IsMobileActivated = response.data.isMobileActivated;
            //console.log("Email: " + this.IsEMailActivated);
            //console.log("Mobile: " + this.IsMobileActivated);
            FlashMessage.show(
              "<span style='color:Green'>" + response.data.msg + "</span><br/>",
              3000
            );
          } else {
            this.generateForgotOTP();
            FlashMessage.show(
              "<span style='color:Red'>" + response.data.msg + "</span><br/>",
              3000
            );
          }
        },
        error => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        failure => {
          alert("Failure: " + failure);
        }
      );
    },
    verifyOTP(type) {
      let userEMail = "";
      let userMobile = "";
      let eMailOTP = "";
      let mobileOTP = "";
      if (type == 1) {
        userEMail =
          this.isEMailOTPRequired == true ? this.userEmail.trim() : "";
        eMailOTP = this.isEMailOTPRequired == true ? this.emailOTP.trim() : "";
        userMobile = this.userMobile.trim();
        mobileOTP =
          this.isMobileOTPRequired == true ? this.mobileOTP.trim() : "";
        if (this.emailVerified == false) {
          if (userEMail == "") {
            alert("Please enter the email");
            return false;
          }
          if (eMailOTP == "") {
            alert("Please enter the email OTP");
            return false;
          }
        }
        if (this.mobVerified == false) {
          if (userMobile == "") {
            alert("Please enter the mobile number");
            return false;
          }
          if (mobileOTP == "") {
            alert("Please enter the mobile OTP");
            return false;
          }
        }
      }
      let _paramsData = {
        userEMail: userEMail,
        userMobile: userMobile,
        eMailOTP: eMailOTP,
        mobileOTP: mobileOTP,
        type: type
      };
      LoginJs.OTPVerification(_paramsData).then(
        response => {
          alert(response.data.msg);
          if (response.data.isSuccess) {
            this.eMailOTPRef = "";
            this.mobileOTPRef = "";
            if (type == 1) {
              this.isVerifyOTPReq = false;
              // this.hideCreateAccount();
              this.getUserProfile();
            }
          }
        },
        error => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        failure => {
          alert("Failure: " + failure);
        }
      );
    },
    // removeDocuments(index) {
    //   this.document_List.splice(index, 1);
    // },
    addDocuments() {
      var file = "";
      var fileName = "";
      var fileExt = "";
      this.uploadedFile.forEach(function(item, index) {
        file = item.filePreview.split(",")[1];
        fileName = item.docFileName;
        fileExt = item.ext;
      });
      this.document_List.push({
        idDocument: "",
        idImageFile: file,
        idImageFileExtension: fileExt,
        idImageFileName: fileName,
        idNumber: this.idNumber,
        idType: this.idType,
        idTypeName: this.idType_List[this.idType - 1][1],
        type: 0
      });
      // console.log(this.document_List);
      this.idType = -1;
      this.idNumber = "";
    },
    generateCaptcha() {
      this.captchaValue = "";
      LoginJs.GenerateCaptcha().then(
        response => {
          $("#imgCaptchaForEmailVerification").attr(
            "src",
            response.data.result1
          );
          this.captchaKeyEmailVerification = response.data.result;
        },
        error => {
          if (error.response.data.message != undefined) {
            alert(
              error.response.data.message +
                "\n" +
                error.response.data.exceptionMessage
            );
          } else {
            alert("Error: " + error.response.data);
          }
        },
        failure => {
          alert("Failure: " + failure.response);
        }
      );
    }
  },
  mounted() {
    this.GetSetupData();
    // this.getIDTypeList();
  }
};
</script>

<style scoped>
.wrapText {
  overflow: anywhere;
}
fieldset {
  margin-bottom: 4px !important;
}
fieldset > div {
  overflow: hidden;
}
.myhead::-webkit-scrollbar {
  background-color: transparent;
}
.myhead::scrollbar {
  background-color: transparent;
}
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 11pt;
}
.mandatorySpan1 {
  text-align: left;
  position: relative;
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 11pt;
}
.mandatorySpan1.Required:after {
  color: red;
  content: "*";
  position: relative;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
#divUserProfile {
  margin-left: 4px;
  margin-right: 5px;
  /* border: dotted 1px darkgray;
  border-radius: 5px;
  padding: 5px 0px 5px 5px; */
}
.rblGender input[type="radio"] {
  position: fixed;
  width: 0;
  cursor: pointer;
  opacity: 0.55;
}
.rblDiv {
  display: inline;
  margin-right: 5%;
}
</style>
<style scoped>
@media screen and (max-width: 800px) {
  .EntryBlock {
    width: 80%;
  }
  #divApplication {
    display: block;
    height: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .EntryBlock {
    width: 100%;
  }
  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }
  .tblEntryForm {
    width: calc(100vw - 35px);
  } /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  } /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  } /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  } /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }
  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }
  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
  .disabled {
    background-color: rgb(192 222 243) !important;
  }
}
.cand_photo {
  height: 120px;
  width: 150px;
  border: solid 1px black;
}
#video {
  border: 1px solid black;
  width: 320px;
  height: 240px;
}

#photo {
  border: 1px solid black;
  width: 320px;
  height: 240px;
}

#canvas {
  display: none;
}

.camera {
  width: 340px;
  display: inline-block;
}

.output {
  width: 340px;
  display: inline-block;
}

#startbutton {
  position: relative;
  padding: 5px;
  background-color: #6a67ce;
  border: 1px solid rgba(255, 255, 255, 0.7);
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
}

.contentarea {
  font-size: 16px;
  font-family: Arial;
  text-align: center;
}
@media screen and (max-width: 480px) {
  .EntryBlock {
    width: calc(100vw - 35px);
  }
  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }
  .tblEntryForm .divHR {
    display: block;
  }
  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }
  legend {
    width: calc(100vw - 40px) !important;
  }
  .disabled {
    background-color: rgb(192 222 243) !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/UserProfile.vue